import moment from "moment";
import jwtDecode from "jwt-decode";
import round from "lodash.round";

const calculatePrice = (prices, configuration) => {
  const { seats, vpnSeats, sku, license } = configuration;

  const minSeats = (seats < 1) ? 1 : seats

  const seatPrice = prices[license][sku];
  const discountMultiplier = 1 - (prices.discount || 0);
  const vpnPrice = prices.vpn
  const vpnPricePerMonth = round(vpnPrice * vpnSeats * discountMultiplier, 2)
  const vpnPricePerYear = round(vpnPrice * vpnSeats * discountMultiplier * 12, 2)

  return {
    pricePerUser: round(seatPrice * discountMultiplier, 2),
    pricePerVpnSeat: round(vpnPrice * discountMultiplier, 2),
    pricePerMonth: round((seatPrice * minSeats * discountMultiplier) + vpnPricePerMonth, 2),
    vpnPricePerMonth: round(vpnPrice * vpnSeats * discountMultiplier, 2),
    pricePerYear: round((seatPrice * minSeats * discountMultiplier * 12) + vpnPricePerYear, 2),

  }
}

const reduce = (state, action) => {
  switch (action.type) {
    case "SET_GLOBAL_ERROR":
      return {
        ...state, error: {
          message: action.payload.message,
          isFatal: action.payload.fatal
        }
      }

    case "SET_PRICING":
      return { ...state, pricing: action.payload };

    case "UPDATE_PRICES":
      return {
        ...state,
        configuration: {
          ...state.configuration,
          ...calculatePrice(state.pricing, state.configuration)
        }
      };

    case "SET_PROCESSING_SPINNER":
      return { ...state, isProcessing: action.payload };

    case "UPDATE_CONFIGURATION":
      return {
        ...state,
        configuration: {
          ...state.configuration,
          ...action.payload
        }
      }

    case "SET_SUBSCRIPTION":
      return { ...state, payment: action.payload };

    case "CLEAR_ACTIVATION_KEY":
      return {
        ...state,
        activation: {
          activationKey: "",
          customer: "",
          type: "",
          sku: "",
          startDate: "",
          endDate: ""
        }
      };

    case "SET_ACTIVATION_KEY":
      const entitlement = jwtDecode(action.payload);

      const formattedActivationKey = action.payload
        .match(/.{1,40}/g)
        .join("\n");
      
      return {
        ...state,
        activation: {
          ...state.activation,
          activationKey: `-----BEGIN ACTIVATION KEY-----\n${formattedActivationKey}\n-----END ACTIVATION KEY-----`,
          customer: entitlement.issued_to,
          type: entitlement.license_type,
          sku: entitlement.sku,
          startDate: moment.unix(entitlement.iat).format("MM-DD-YYYY"),
          endDate: moment.unix(entitlement.exp).format("MM-DD-YYYY"),
        }
      };

    case "SET_INSTALLATION_ID":
      return {
        ...state,
        activation: {
          ...state.activation,
          installationId: action.payload
        }
      }

    case "SET_LICENSE_KEY":
      const formattedLicenseKey = action.payload
        .match(/.{1,40}/g)
        .join("\n");

      return {
        ...state,
        license: {
          key: `-----BEGIN LICENSE KEY-----\n${formattedLicenseKey}\n-----END LICENSE KEY-----`,
        }
      }

    default:
      return state;
  }
}

export default reduce;